.#{$namespace}-form {
	box-sizing: border-box;
	width: 100%;

	// theme-chalk 是全局样式，不要写 :deep()（那是 Vue scoped 语法，浏览器不认）
	&--label-top {
		.#{$namespace}-form-item {
			flex-direction: column;
			align-items: stretch;

			.#{$namespace}-form-item__label {
				text-align: left;
				padding: 0 0 8px;
				height: auto;
				line-height: 1.5;
				justify-content: flex-start;
			}

			// label 在上时是 column，content 的 flex:1 会竖着拉满
			// 父级再被栅格 stretch，校验文案就会离开输入框
			.#{$namespace}-form-item__content {
				flex-grow: 0;
				width: 100%;
			}
		}
	}

	&--label-left {
		.#{$namespace}-form-item__label {
			justify-content: flex-start;
			text-align: left;
		}
	}

	&--label-right {
		.#{$namespace}-form-item__label {
			justify-content: flex-end;
			text-align: right;
		}
	}

	&.is-disabled {
		cursor: not-allowed;
		// 子控件漏 inject Form.disabled 时至少整表不能点
		pointer-events: none;
	}
}
